export * from './OutOfStockTag.ui';
